export const BIRTHDAY_PREVIEW_CONNECTIONS = [
    {
        _id: 'preview-birthday-1',
        firstName: 'Natalie',
        lastName: 'Kim',
        birthDate: { month: 6, day: 12, year: 1988 },
        profilePicture: '',
        _isPreview: true,
    },
    {
        _id: 'preview-birthday-2',
        firstName: 'Noah',
        lastName: 'Bennett',
        birthDate: { month: 8, day: 15, year: 1990 },
        profilePicture: '',
        _isPreview: true,
    },
]

export const JOB_CHANGE_PREVIEW_CONNECTIONS = [
    {
        _id: 'preview-job-1',
        firstName: 'Floyd',
        lastName: 'Miles',
        profilePicture: '',
        profileChangedAt: {
            job: {
                previousTitle: 'Marketing Manager',
                newTitle: 'Head of Marketing',
            },
            company: {
                newCompany: 'BForce Veltro Systems',
            },
        },
        _isPreview: true,
    },
    {
        _id: 'preview-job-2',
        firstName: 'Kristin',
        lastName: 'Watson',
        profilePicture: '',
        profileChangedAt: {
            job: {
                newTitle: 'Product Designer',
            },
            company: {
                newCompany: 'Acme Corp',
            },
        },
        _isPreview: true,
    },
]
